/**
 * Indica si todas las palabras del término de búsqueda están presentes en el texto
 * (en cualquier orden). Ej: "pov salis a caminar" coincide con texto que contenga
 * "pov", "salis", "a" y "caminar" en cualquier posición.
 * @param {string} text - Texto donde buscar
 * @param {string} searchTerm - Término de búsqueda (puede ser varias palabras)
 * @returns {boolean}
 */
export function allWordsPresent(text, searchTerm) {
  const words = (searchTerm || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return false;
  const lower = (text || '').toLowerCase();
  return words.every(word => lower.includes(word));
}
